'use client'
import React, { FC, useEffect, useRef, useState } from 'react'
import { IHomePageTemplateSubjectsBlock } from '@/types/firebase'
import Image from 'next/image'
import Engineering from '@/images/home/education.png'
import Science from '@/images/home/science.png'
import Technology from '@/images/home/technology.png'
import Mathematics from '@/images/home/mathematics.png'
import {
  EngineeringIcon,
  TechnologyIcon,
  SvgMathematicsIcon,
} from '@/components/icons'
import { SvgScienceIcon } from '@/components/icons/science-icon'

interface Props {
  customContent: IHomePageTemplateSubjectsBlock
}

export const CommonSubjectsBlock: FC<Props> = ({}) => {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null)
  const contentRef = useRef<HTMLDivElement | null>(null)
  const [scrollPos, setScrollPos] = useState(0)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setScrollPos((prevScrollPos) => {
        const newScrollPos = prevScrollPos + 1
        if (
          contentRef.current &&
          scrollContainerRef.current &&
          newScrollPos >=
            contentRef.current.offsetHeight -
              scrollContainerRef.current?.offsetHeight
        ) {
          return 0
        }
        return newScrollPos
      })
    }, 20)
    return () => clearInterval(intervalId)
  }, [])

  return (
    <div className="w-full mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="lg:grid lg:grid-cols-2">
        <div className="lg:w-[503px] my-auto lg:pb-0 pb-[20px]">
          <p className="text-v8-violet text-[16px] leading-[24px] font-semibold lg:text-left text-center">
            What do we teach
          </p>
          <h1 className="text-v8-ink text-[36px] font-semibold leading-[44px] lg:text-left text-center mt-[10px]">
            We specialize in STEM subjects
          </h1>
          <p className="mt-[15px] text-v8-ink lg:text-left text-center text-[20px]">
            We provide tuition for STEM subjects at all levels. From the Primary
            level to the University level, we cover all aspects of your
            curriculum.
          </p>
        </div>

        <div className="relative">
          <div className="bg-create  h-36 w-full absolute"></div>
          <article
            ref={scrollContainerRef}
            className="max-height-carousel overflow-y-scroll no-scrollbar snap snap-y snap-mandatory"
          >
            <section
              ref={contentRef}
              className="w-full px-2"
              style={{ marginTop: `-${scrollPos}px` }}
            >
              <div className="my-[25px] grid grid-cols-3 rounded-[20px] p-[24px] gap-4 shadow-v8-card">
                <div className="col-span-2">
                  <h1 className="my-2 text-[20px] font-semibold text-v8-ink leading-[30px]"></h1>
                  <p className="text-[16px] leading-[24px] text-v8-mut font-medium"></p>
                </div>
                <div className=""></div>
              </div>
              <div className="bg-white my-[25px] grid grid-cols-3 rounded-[20px] p-[24px] gap-4 shadow-v8-card">
                <div className="col-span-2">
                  <SvgScienceIcon rect={{ height: '48', width: '48' }} />
                  <h1 className="my-2 text-[20px] font-semibold text-v8-ink leading-[30px]">
                    Science
                  </h1>
                  <p className="text-[16px] leading-[24px] text-v8-mut font-medium">
                    We work to build each student’s confidence and give them the
                    courage to ask questions in class
                  </p>
                </div>
                <div className="">
                  <Image src={Engineering} alt="Engineering"></Image>
                </div>
              </div>
              <div className="bg-white my-[25px] grid grid-cols-3 rounded-[20px] p-[24px] gap-4 shadow-v8-card">
                <div className="col-span-2">
                  <TechnologyIcon className="w-14 h-14" />
                  <h1 className="my-2 text-[20px] font-semibold text-v8-ink leading-[30px]">
                    Technology
                  </h1>
                  <p className="text-[16px] leading-[24px] text-v8-mut font-medium">
                    We work to build each student’s confidence and give them the
                    courage to ask questions in class
                  </p>
                </div>
                <div>
                  <Image src={Technology} alt="Technology"></Image>
                </div>
              </div>
              <div className="bg-white my-[25px]  grid grid-cols-3 rounded-[20px] p-[24px] gap-4 shadow-v8-card">
                <div className="col-span-2">
                  <EngineeringIcon className="w-14 h-14" />
                  <h1 className="my-2 text-[20px] font-semibold text-v8-ink leading-[30px]">
                    Engineering
                  </h1>
                  <p className="text-[16px] leading-[24px] text-v8-mut font-medium">
                    We work to build each student’s confidence and give them the
                    courage to ask questions in class
                  </p>
                </div>
                <div>
                  <Image src={Science} alt="Science"></Image>
                </div>
              </div>
              <div className="bg-white my-[25px]  grid grid-cols-3 rounded-[20px] p-[24px] gap-4 shadow-v8-card">
                <div className="col-span-2">
                  <SvgMathematicsIcon className="w-14 h-14" />
                  <h1 className="my-2 text-[20px] font-semibold text-v8-ink leading-[30px]">
                    Mathematics
                  </h1>
                  <p className="text-[16px] leading-[24px] text-v8-mut font-medium">
                    We work to build each student’s confidence and give them the
                    courage to ask questions in class
                  </p>
                </div>
                <div>
                  <Image src={Mathematics} alt="Mathematics"></Image>
                </div>
              </div>
              <div className="my-[25px] grid grid-cols-3 rounded-[20px] p-[24px] gap-4 shadow-v8-card">
                <div className="col-span-2">
                  <h1 className="my-2 text-[20px] font-semibold text-v8-ink leading-[30px]"></h1>
                  <p className="text-[16px] leading-[24px] text-v8-mut font-medium"></p>
                </div>
                <div className=""></div>
              </div>
            </section>
          </article>
          <div className="bg-create translate-bg bottom-[0px] h-36 w-full absolute"></div>
        </div>
      </div>
    </div>
  )
}
